import ViewState from "@mapmycustomers/shared/types/viewModel/ViewState";

import { getTaggedFilterModelForActivities } from "@app/util/viewModel/getTaggedFilterModelForActivities";

// Note: this function could be moved into LocalSettings.getViewSettings, but that breaks webpack
// module compilation. So I had to keep it separate and apply only in certain views.
export const preprocessViewStateForActivities = (viewState: ViewState): ViewState => {
  const [taggedFilterModel] = getTaggedFilterModelForActivities(viewState.filter);
  return { ...viewState, filter: taggedFilterModel };
};
